let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("4DY11")), load("3u3Tm")]).then(() => parcelRequire('bwkSx'));